<template>
	<div>
		<!-- 第一组完全保持原样 -->
		<van-grid column-num="2">
			<van-grid-item :dot="subject.categoryId === '109'" @click="$emit('click', ['categoryId', '109'])">
				<template #icon>
					<img height="84" src="@/assets/vip-home/cy_05.png" alt="客运">
				</template>
			</van-grid-item>
			<van-grid-item :dot="subject.categoryId === '110'" @click="$emit('click', ['categoryId', '110'])">
				<template #icon>
					<img height="84" src="@/assets/vip-home/cy_03.png" alt="货运">
				</template>
			</van-grid-item>
			<van-grid-item :dot="subject.categoryId === '111'" @click="$emit('click', ['categoryId', '111'])">
				<template #icon>
					<img height="84" src="@/assets/vip-home/cy_09.png" alt="出租车">
				</template>
			</van-grid-item>
			<van-grid-item :dot="subject.categoryId === '112'" @click="$emit('click', ['categoryId', '112'])">
				<template #icon>
					<img height="84" src="@/assets/vip-home/cy_10.png" alt="教练员">
				</template>
			</van-grid-item>
			<van-grid-item :dot="subject.categoryId === '113'" @click="$emit('click', ['categoryId', '113'])">
				<template #icon>
					<img height="84" src="@/assets/vip-home/cy_15.png" alt="危险品">
				</template>
			</van-grid-item>
			<van-grid-item :dot="subject.categoryId === '114'" @click="$emit('click', ['categoryId', '114'])">
				<template #icon>
					<img height="84" src="@/assets/vip-home/cy_14.png" alt="网约车">
				</template>
			</van-grid-item>
		</van-grid>

		<!-- 第二组：强制 3 列一行，图片等比缩放 -->
		<van-grid column-num="3" class="grid-three">
			<van-grid-item :dot="subject.categoryId === '232'" @click="$emit('click', ['categoryId', '232'])">
				<template #icon>
					<img class="grid-img" src="@/assets/vip-home/cy_16.png" alt="危货驾驶员">
				</template>
			</van-grid-item>
			<van-grid-item :dot="subject.categoryId === '233'" @click="$emit('click', ['categoryId', '233'])">
				<template #icon>
					<img class="grid-img" src="@/assets/vip-home/cy_17.png" alt="危货押运员">
				</template>
			</van-grid-item>
			<van-grid-item :dot="subject.categoryId === '234'" @click="$emit('click', ['categoryId', '234'])">
				<template #icon>
					<img class="grid-img" src="@/assets/vip-home/cy_18.png" alt="装卸管理员">
				</template>
			</van-grid-item>
		</van-grid>
	</div>
</template>

<script>
export default {
	props: ['subject'],
};
</script>

<style scoped lang="less">
.grid-three {
	/* ★ 关键：解除 flex 子项 min-width:auto，允许收缩到 1/3 */
	:deep(.van-grid-item) {
		min-width: 0;
		max-width: 33.3333%;
		flex: 0 0 33.3333%;
	}

	:deep(.van-grid-item__content) {
		padding: 8px 4px;
		box-sizing: border-box;
		min-width: 0;
		overflow: hidden;
	}

	:deep(.van-grid-item__icon) {
		width: 100%;
		height: 84px;              /* 与第一组图片高度一致 */
		display: flex;
		align-items: center;
		justify-content: center;
		overflow: hidden;
	}

	.grid-img {
		display: block;
		width: 100%;
		max-width: 100%;
		height: 84px;
		object-fit: contain;       /* 过宽等比缩小，不溢出 */
	}
}
</style>
